import React from 'react';
import GamesForm from '../Components/GamesForm';

const AddGame = () => {
  return (
    <div>
      <GamesForm />
    </div>
  );
};

export default AddGame;
